








































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BModal, BIcon, BIconExclamationTriangle } from 'bootstrap-vue';
import moment from 'moment';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Budget from '~/models/budget';

@Component({
	components: {
		ValidationProvider,
		ValidationObserver,
		BIcon,
		BIconExclamationTriangle
	},
})
export default class SidebarModify extends Vue {
	$refs!: {
		modal: BModal;
	};
	private budget: any = {};
	private minDateStartModel: any = '';
	private maxDateStartModel: any = '';
	private minDateFinishModel: any = '';
	private maxDateFinishModel: any = '';
	private maxDaysModel: any = 0;
	private minDaysModel: any = 0;
	private styleModal: any = '';

	constructor() {
		super();
		this.budget = {};
	}

	recalculate() {
		this.$emit('recalculate', this.budget);
	}

	calulateDays() {
		if (this.budget.start_date && this.budget.end_date) {
			const start = moment(this.budget.end_date).diff(moment(this.budget.start_date), 'days') + 1;
			const end = moment(this.budget.end_date).diff(moment(this.budget.start_date), 'days');
			const res = start + '/' + end;
			return res;
		} else {
			return '0/0';
		}
	}

	showModal(budget) {
		this.budget = Budget.copy(budget);
		this.minDateStartModel = new Date();
		this.maxDateStartModel = new Date(this.budget.travel_season_end);
		this.minDaysModel = this.budget.travel_duration_min;
		this.maxDaysModel = this.budget.travel_duration_max - 1;
		this.maxDateOnly();
		this.$refs.modal.show();
	}

	closeModal() {
		this.$refs.modal.hide();
	}

	maxDateOnly() {
		this.maxDateFinishModel = new Date(this.budget.start_date);
		this.maxDateFinishModel.setDate(this.maxDateFinishModel.getDate() + this.maxDaysModel);
		this.minDateFinishModel = new Date(this.budget.start_date);
		this.minDateFinishModel.setDate(this.minDateFinishModel.getDate() + this.minDaysModel);
	}

	showCalendar() {
		this.styleModal = 'height:400px';
	}

	hideCalendar() {
		this.styleModal = '';
	}
}
